var map = {
	"./Add-1.svg": [
		62576,
		62576
	],
	"./Add-Bell-Notification.svg": [
		37269,
		37269
	],
	"./Add-Circle.svg": [
		64272,
		64272
	],
	"./Add-Layer-2.svg": [
		62183,
		62183
	],
	"./Add-Square.svg": [
		7333,
		7333
	],
	"./Adobe.svg": [
		76870,
		76870
	],
	"./Affordable-And-Clean-Energy.svg": [
		67547,
		67547
	],
	"./Ai-Chip-Spark.svg": [
		35182,
		35182
	],
	"./Ai-Cloud-Spark.svg": [
		30747,
		30747
	],
	"./Ai-Edit-Spark.svg": [
		89321,
		89321
	],
	"./Ai-Email-Generator-Spark.svg": [
		92313,
		92313
	],
	"./Ai-Gaming-Spark.svg": [
		83562,
		83562
	],
	"./Ai-Generate-Landscape-Image-Spark.svg": [
		75930,
		75930
	],
	"./Ai-Generate-Music-Spark.svg": [
		11354,
		11354
	],
	"./Ai-Generate-Portrait-Image-Spark.svg": [
		25318,
		25318
	],
	"./Ai-Generate-Variation-Spark.svg": [
		61630,
		61630
	],
	"./Ai-Navigation-Spark.svg": [
		23414,
		23414
	],
	"./Ai-Network-Spark.svg": [
		44087,
		44087
	],
	"./Ai-Prompt-Spark.svg": [
		51093,
		51093
	],
	"./Ai-Redo-Spark.svg": [
		54030,
		54030
	],
	"./Ai-Science-Spark.svg": [
		10732,
		10732
	],
	"./Ai-Settings-Spark.svg": [
		33570,
		33570
	],
	"./Ai-Technology-Spark.svg": [
		9100,
		9100
	],
	"./Ai-Upscale-Spark.svg": [
		83109,
		83109
	],
	"./Ai-Vehicle-Spark-1.svg": [
		26211,
		26211
	],
	"./Airplane-Disabled.svg": [
		31191,
		31191
	],
	"./Airplane-Enabled.svg": [
		26406,
		26406
	],
	"./Airplane.svg": [
		15521,
		15521
	],
	"./Airport-Plane-Transit.svg": [
		33361,
		33361
	],
	"./Airport-Plane.svg": [
		8686,
		8686
	],
	"./Airport-Security.svg": [
		37595,
		37595
	],
	"./Alarm-Clock.svg": [
		94173,
		94173
	],
	"./Alien.svg": [
		23491,
		23491
	],
	"./Align-Back-1.svg": [
		15459,
		15459
	],
	"./Align-Center.svg": [
		89874,
		89874
	],
	"./Align-Front-1.svg": [
		81334,
		81334
	],
	"./Align-Left.svg": [
		71559,
		71559
	],
	"./Align-Right.svg": [
		74485,
		74485
	],
	"./Alt.svg": [
		18005,
		18005
	],
	"./Amazon.svg": [
		18828,
		18828
	],
	"./Ambulance.svg": [
		38969,
		38969
	],
	"./Ampersand.svg": [
		95103,
		95103
	],
	"./Anchor.svg": [
		91081,
		91081
	],
	"./Android.svg": [
		11384,
		11384
	],
	"./Announcement-Megaphone.svg": [
		91128,
		91128
	],
	"./App-Store.svg": [
		11442,
		11442
	],
	"./Apple.svg": [
		27513,
		27513
	],
	"./Application-Add.svg": [
		23993,
		23993
	],
	"./Archive-Box.svg": [
		60225,
		60225
	],
	"./Arrow-Bend-Left-Down-2.svg": [
		66475,
		66475
	],
	"./Arrow-Bend-Right-Down-2.svg": [
		94734,
		94734
	],
	"./Arrow-Crossover-Down.svg": [
		70855,
		70855
	],
	"./Arrow-Crossover-Left.svg": [
		56133,
		56133
	],
	"./Arrow-Crossover-Right.svg": [
		72383,
		72383
	],
	"./Arrow-Crossover-Up.svg": [
		4503,
		4503
	],
	"./Arrow-Cursor-1.svg": [
		38077,
		38077
	],
	"./Arrow-Cursor-2.svg": [
		96189,
		96189
	],
	"./Arrow-Curvy-Up-Down-1.svg": [
		26997,
		26997
	],
	"./Arrow-Curvy-Up-Down-2.svg": [
		78978,
		78978
	],
	"./Arrow-Down-2.svg": [
		72150,
		72150
	],
	"./Arrow-Down-4.svg": [
		34370,
		34370
	],
	"./Arrow-Down-Dashed-Square.svg": [
		37265,
		37265
	],
	"./Arrow-Expand.svg": [
		92687,
		92687
	],
	"./Arrow-Infinite-Loop.svg": [
		90285,
		90285
	],
	"./Arrow-Left.svg": [
		6489,
		6489
	],
	"./Arrow-Move.svg": [
		98546,
		98546
	],
	"./Arrow-Reload-Horizontal-1.svg": [
		81961,
		81961
	],
	"./Arrow-Reload-Horizontal-2.svg": [
		33205,
		33205
	],
	"./Arrow-Reload-Vertical-1.svg": [
		24861,
		24861
	],
	"./Arrow-Reload-Vertical-2.svg": [
		65071,
		65071
	],
	"./Arrow-Right.svg": [
		4336,
		4336
	],
	"./Arrow-Roadmap.svg": [
		91770,
		91770
	],
	"./Arrow-Round-Left.svg": [
		21929,
		21929
	],
	"./Arrow-Round-Right.svg": [
		32879,
		32879
	],
	"./Arrow-Shrink-Diagonal-1.svg": [
		83084,
		83084
	],
	"./Arrow-Shrink-Diagonal-2.svg": [
		46933,
		46933
	],
	"./Arrow-Shrink.svg": [
		13383,
		13383
	],
	"./Arrow-Transfer-Diagonal-1.svg": [
		71573,
		71573
	],
	"./Arrow-Transfer-Diagonal-2.svg": [
		33185,
		33185
	],
	"./Arrow-Transfer-Diagonal-3.svg": [
		88079,
		88079
	],
	"./Arrow-Up-1.svg": [
		16192,
		16192
	],
	"./Arrow-Up-2.svg": [
		67542,
		67542
	],
	"./Arrow-Up-Dashed-Square.svg": [
		93464,
		93464
	],
	"./Artificial-Intelligence-Spark.svg": [
		10194,
		10194
	],
	"./Ascending-Number-Order.svg": [
		26491,
		26491
	],
	"./Asterisk-1.svg": [
		17107,
		17107
	],
	"./Attribution.svg": [
		79770,
		92583
	],
	"./Auto-Flash.svg": [
		51838,
		51838
	],
	"./Back-Camera-1.svg": [
		9314,
		9314
	],
	"./Backpack.svg": [
		30337,
		30337
	],
	"./Bacteria-Virus-Cells-Biology.svg": [
		83142,
		83142
	],
	"./Bag-Dollar.svg": [
		82018,
		82018
	],
	"./Bag-Pound.svg": [
		71510,
		71510
	],
	"./Bag-Rupee.svg": [
		14089,
		14089
	],
	"./Bag-Suitcase-1.svg": [
		49608,
		49608
	],
	"./Bag-Suitcase-2.svg": [
		75068,
		75068
	],
	"./Bag-Won.svg": [
		20503,
		20503
	],
	"./Bag-Yen.svg": [
		28222,
		28222
	],
	"./Bag.svg": [
		22926,
		22926
	],
	"./Baggage.svg": [
		81525,
		81525
	],
	"./Ball.svg": [
		86681,
		86681
	],
	"./Balloon.svg": [
		47322,
		47322
	],
	"./Bandage.svg": [
		7982,
		7982
	],
	"./Bank.svg": [
		39186,
		39186
	],
	"./Battery-Alert-1.svg": [
		85562,
		85562
	],
	"./Battery-Charging.svg": [
		77185,
		77185
	],
	"./Battery-Empty-1.svg": [
		78630,
		78630
	],
	"./Battery-Empty-2.svg": [
		76178,
		76178
	],
	"./Battery-Full-1.svg": [
		57002,
		57002
	],
	"./Battery-Low-1.svg": [
		62873,
		62873
	],
	"./Battery-Medium-1.svg": [
		74622,
		74622
	],
	"./Beach.svg": [
		59247,
		59247
	],
	"./Beanie.svg": [
		45907,
		45907
	],
	"./Beer-Mug.svg": [
		56006,
		56006
	],
	"./Beer-Pitch.svg": [
		50150,
		50150
	],
	"./Bicycle-Bike.svg": [
		92876,
		92876
	],
	"./Bill-1.svg": [
		55059,
		55059
	],
	"./Bill-2.svg": [
		98808,
		98808
	],
	"./Bill-4.svg": [
		45484,
		45484
	],
	"./Bill-Cashless.svg": [
		50078,
		50078
	],
	"./Binance-Circle.svg": [
		41808,
		41808
	],
	"./Bitcoin.svg": [
		64403,
		64403
	],
	"./Blank-Calendar.svg": [
		9116,
		9116
	],
	"./Blank-Notepad.svg": [
		83615,
		83615
	],
	"./Block-Bell-Notification.svg": [
		74792,
		74792
	],
	"./Blood-Bag-Donation.svg": [
		42990,
		42990
	],
	"./Blood-Donate-Drop.svg": [
		76584,
		76584
	],
	"./Blood-Drop-Donation.svg": [
		65648,
		65648
	],
	"./Bluetooth-Disabled.svg": [
		2303,
		2303
	],
	"./Bluetooth-Searching.svg": [
		79650,
		79650
	],
	"./Bluetooth.svg": [
		76470,
		76470
	],
	"./Bomb.svg": [
		81610,
		81610
	],
	"./Bone.svg": [
		82032,
		25267
	],
	"./Book-Reading.svg": [
		6759,
		6759
	],
	"./Bookmark-Fill.svg": [
		2398,
		2398
	],
	"./Bookmark.svg": [
		87024,
		87024
	],
	"./Bow-Tie.svg": [
		35234,
		35234
	],
	"./Bow.svg": [
		5395,
		5395
	],
	"./Box-Sign.svg": [
		34017,
		34017
	],
	"./Braces-Circle.svg": [
		7473,
		7473
	],
	"./Bracket.svg": [
		99880,
		99880
	],
	"./Braille-Blind.svg": [
		6333,
		6333
	],
	"./Brain-Cognitive.svg": [
		92398,
		92398
	],
	"./Brain.svg": [
		8208,
		8208
	],
	"./Briefcase-Dollar.svg": [
		32336,
		32336
	],
	"./Brightness-1.svg": [
		99802,
		99802
	],
	"./Brightness-2.svg": [
		27345,
		27345
	],
	"./Brightness-3.svg": [
		59782,
		59782
	],
	"./Broken-Link-2.svg": [
		31760,
		31760
	],
	"./Browser-Add.svg": [
		84489,
		84489
	],
	"./Browser-Block.svg": [
		75015,
		75015
	],
	"./Browser-Build.svg": [
		93563,
		93563
	],
	"./Browser-Check.svg": [
		97990,
		97990
	],
	"./Browser-Delete.svg": [
		6298,
		6298
	],
	"./Browser-Hash.svg": [
		64883,
		64883
	],
	"./Browser-Lock.svg": [
		91071,
		91071
	],
	"./Browser-Multiple-Window.svg": [
		28223,
		28223
	],
	"./Browser-Remove.svg": [
		4966,
		4966
	],
	"./Browser-Website-1.svg": [
		39779,
		39779
	],
	"./Browser-Wifi.svg": [
		1637,
		1637
	],
	"./Bug-Antivirus-Debugging.svg": [
		87846,
		87846
	],
	"./Bug-Antivirus-Shield.svg": [
		43070,
		43070
	],
	"./Bug-Virus-Browser.svg": [
		21567,
		21567
	],
	"./Bug-Virus-Document.svg": [
		36395,
		36395
	],
	"./Bug-Virus-Folder.svg": [
		36465,
		36465
	],
	"./Bug.svg": [
		99516,
		99516
	],
	"./Building-2.svg": [
		21208,
		21208
	],
	"./Bullet-List.svg": [
		49467,
		49467
	],
	"./Burger.svg": [
		55020,
		55020
	],
	"./Burrito-Fastfood.svg": [
		39704,
		39704
	],
	"./Bus.svg": [
		61034,
		61034
	],
	"./Business-Card.svg": [
		22616,
		22616
	],
	"./Business-Handshake.svg": [
		68534,
		68534
	],
	"./Business-Idea-Money.svg": [
		51284,
		51284
	],
	"./Business-Profession-Home-Office.svg": [
		78471,
		78471
	],
	"./Business-Progress-Bar-2.svg": [
		86010,
		86010
	],
	"./Business-User-Curriculum.svg": [
		99107,
		99107
	],
	"./Button-Fast-Forward-1.svg": [
		85784,
		85784
	],
	"./Button-Fast-Forward-2.svg": [
		52927,
		52927
	],
	"./Button-Next.svg": [
		23745,
		23745
	],
	"./Button-Pause-2.svg": [
		81019,
		81019
	],
	"./Button-Play.svg": [
		82686,
		82686
	],
	"./Button-Power-1.svg": [
		8531,
		8531
	],
	"./Button-Previous.svg": [
		59876,
		59876
	],
	"./Button-Record-3.svg": [
		77739,
		77739
	],
	"./Button-Rewind-1.svg": [
		17483,
		17483
	],
	"./Button-Rewind-2.svg": [
		24242,
		24242
	],
	"./Button-Stop.svg": [
		22401,
		22401
	],
	"./Cake-Slice.svg": [
		19831,
		19831
	],
	"./Calculator-1.svg": [
		79688,
		79688
	],
	"./Calculator-2.svg": [
		23311,
		23311
	],
	"./Calendar-Add.svg": [
		50012,
		50012
	],
	"./Calendar-Edit.svg": [
		77348,
		77348
	],
	"./Calendar-Jump-To-Date.svg": [
		38395,
		38395
	],
	"./Calendar-Star.svg": [
		49142,
		49142
	],
	"./Call-Center-Support-Service.svg": [
		34711,
		34711
	],
	"./Call-Hang-Up.svg": [
		76745,
		76745
	],
	"./Camera-1.svg": [
		68721,
		68721
	],
	"./Camera-Disabled.svg": [
		47389,
		47389
	],
	"./Camera-Loading.svg": [
		27189,
		27189
	],
	"./Camera-Square.svg": [
		49380,
		49380
	],
	"./Camera-Video.svg": [
		42826,
		42826
	],
	"./Camping-Tent.svg": [
		89223,
		89223
	],
	"./Candy-Cane.svg": [
		89434,
		89434
	],
	"./Cane-1.svg": [
		43061,
		43061
	],
	"./Cane.svg": [
		85764,
		67522
	],
	"./Capitol.svg": [
		13634,
		13634
	],
	"./Car-Battery-Charging.svg": [
		40021,
		40021
	],
	"./Car-Taxi-1.svg": [
		10267,
		10267
	],
	"./Cards.svg": [
		14093,
		14093
	],
	"./Cat-1.svg": [
		27704,
		27704
	],
	"./Cellular-Network-4g.svg": [
		49148,
		49148
	],
	"./Cellular-Network-5g.svg": [
		6692,
		6692
	],
	"./Cellular-Network-Lte.svg": [
		31988,
		31988
	],
	"./Celsius.svg": [
		4046,
		4046
	],
	"./Chair.svg": [
		42197,
		42197
	],
	"./Champagne-Party-Alcohol.svg": [
		59674,
		59674
	],
	"./Chat-Bubble-Oval-Notification.svg": [
		55735,
		55735
	],
	"./Chat-Bubble-Oval-Smiley-1.svg": [
		79827,
		79827
	],
	"./Chat-Bubble-Oval-Smiley-2.svg": [
		48702,
		48702
	],
	"./Chat-Bubble-Oval.svg": [
		6420,
		6420
	],
	"./Chat-Bubble-Square-Block.svg": [
		81743,
		81743
	],
	"./Chat-Bubble-Square-Question.svg": [
		33576,
		33576
	],
	"./Chat-Bubble-Square-Warning.svg": [
		36300,
		36300
	],
	"./Chat-Bubble-Square-Write.svg": [
		68775,
		68775
	],
	"./Chat-Bubble-Text-Square.svg": [
		37678,
		37678
	],
	"./Chat-Bubble-Typing-Oval.svg": [
		15248,
		15248
	],
	"./Chat-Two-Bubbles-Oval.svg": [
		90416,
		90416
	],
	"./Check-Square.svg": [
		28788,
		28788
	],
	"./Check.svg": [
		23494,
		23494
	],
	"./Checkup-Medical-Report-Clipboard.svg": [
		93823,
		93823
	],
	"./Cheese.svg": [
		84965,
		84965
	],
	"./Cherries.svg": [
		66507,
		66507
	],
	"./Chess-Bishop.svg": [
		30148,
		30148
	],
	"./Chess-King.svg": [
		5533,
		5533
	],
	"./Chess-Knight.svg": [
		93370,
		93370
	],
	"./Chess-Pawn.svg": [
		9308,
		9308
	],
	"./Chicken-Grilled-Stream.svg": [
		1951,
		1951
	],
	"./Christian-Cross-1.svg": [
		96552,
		96552
	],
	"./Christian-Cross-2.svg": [
		24566,
		24566
	],
	"./Christianity.svg": [
		17303,
		17303
	],
	"./Chrome.svg": [
		25988,
		25988
	],
	"./Circle-Clock.svg": [
		26681,
		26681
	],
	"./Circle-Flask.svg": [
		71053,
		93456
	],
	"./Circle.svg": [
		24626,
		24626
	],
	"./City-Hall.svg": [
		46736,
		46736
	],
	"./Class-Lesson.svg": [
		48359,
		48359
	],
	"./Clean-Water-And-Sanitation.svg": [
		45386,
		45386
	],
	"./Clipboard-Add.svg": [
		9714,
		9714
	],
	"./Clipboard-Check.svg": [
		58939,
		58939
	],
	"./Clipboard-Remove.svg": [
		46120,
		46120
	],
	"./Closet.svg": [
		85724,
		85724
	],
	"./Cloud-Add.svg": [
		98218,
		98218
	],
	"./Cloud-Block.svg": [
		49700,
		49700
	],
	"./Cloud-Check-Green.svg": [
		1360,
		1360
	],
	"./Cloud-Check.svg": [
		7089,
		7089
	],
	"./Cloud-Data-Transfer.svg": [
		89300,
		89300
	],
	"./Cloud-Gaming-1.svg": [
		56395,
		56395
	],
	"./Cloud-Refresh.svg": [
		67480,
		67480
	],
	"./Cloud-Share.svg": [
		34396,
		34396
	],
	"./Cloud-Warning.svg": [
		87683,
		87683
	],
	"./Cloud-Wifi.svg": [
		53413,
		53413
	],
	"./Cloud.svg": [
		82717,
		82717
	],
	"./Clubs-Symbol.svg": [
		47511,
		47511
	],
	"./Cocktail.svg": [
		25301,
		25301
	],
	"./Code-Analysis.svg": [
		74841,
		74841
	],
	"./Code-Monitor-1.svg": [
		98889,
		98889
	],
	"./Code-Monitor-2.svg": [
		83931,
		83931
	],
	"./Coffee-Bean.svg": [
		93831,
		93831
	],
	"./Coffee-Mug.svg": [
		13217,
		13217
	],
	"./Coffee-Takeaway-Cup.svg": [
		50819,
		50819
	],
	"./Cog.svg": [
		80423,
		80423
	],
	"./Coin-Share.svg": [
		46060,
		46060
	],
	"./Coins-Stack.svg": [
		83801,
		83801
	],
	"./Collaborations-Idea.svg": [
		45700,
		45700
	],
	"./Color-Palette.svg": [
		10150,
		10150
	],
	"./Color-Picker.svg": [
		54156,
		54156
	],
	"./Color-Swatches.svg": [
		42423,
		42423
	],
	"./Comet.svg": [
		72063,
		72063
	],
	"./Command.svg": [
		89287,
		89287
	],
	"./Compass-Navigato.svg": [
		93189,
		93189
	],
	"./Composition-Oval.svg": [
		49439,
		49439
	],
	"./Composition-Vertical.svg": [
		80748,
		80748
	],
	"./Compsition-Horizontal.svg": [
		13107,
		13107
	],
	"./Computer-Chip-1.svg": [
		48976,
		48976
	],
	"./Computer-Chip-2.svg": [
		91668,
		91668
	],
	"./Computer-Pc-Desktop.svg": [
		10782,
		10782
	],
	"./Cone-Shape.svg": [
		92471,
		92471
	],
	"./Contact-Phonebook-2.svg": [
		55858,
		55858
	],
	"./Container.svg": [
		34369,
		34369
	],
	"./Controller-1.svg": [
		43288,
		43288
	],
	"./Controller-Wireless.svg": [
		70040,
		70040
	],
	"./Controller.svg": [
		88987,
		88987
	],
	"./Convert-Pdf-2.svg": [
		8624,
		8624
	],
	"./Copy-Paste.svg": [
		50123,
		50123
	],
	"./Creative-Commons.svg": [
		4022,
		4022
	],
	"./Credit-Card-1.svg": [
		16374,
		16374
	],
	"./Credit-Card-2.svg": [
		3899,
		3899
	],
	"./Crop-Selection.svg": [
		23909,
		23909
	],
	"./Crown.svg": [
		48915,
		48915
	],
	"./Crutch.svg": [
		82810,
		82810
	],
	"./Css-Three.svg": [
		94935,
		94935
	],
	"./Curly-Brackets.svg": [
		92365,
		92365
	],
	"./Cursor-Click.svg": [
		71782,
		71782
	],
	"./Customer-Support-1.svg": [
		44741,
		44741
	],
	"./Cut.svg": [
		35437,
		35437
	],
	"./Cyborg-2.svg": [
		528,
		528
	],
	"./Cyborg.svg": [
		96708,
		96708
	],
	"./Dangerous-Zone-Sign.svg": [
		66615,
		66615
	],
	"./Dark-Dislay-Mode.svg": [
		43712,
		43712
	],
	"./Dashboard-3.svg": [
		30679,
		30679
	],
	"./Dashboard-Circle.svg": [
		13410,
		13410
	],
	"./Database-Check.svg": [
		97618,
		97618
	],
	"./Database-Lock.svg": [
		68935,
		68935
	],
	"./Database-Refresh.svg": [
		82016,
		82016
	],
	"./Database-Remove.svg": [
		34795,
		34795
	],
	"./Database-Server-1.svg": [
		59558,
		59558
	],
	"./Database-Server-2.svg": [
		82989,
		82989
	],
	"./Database-Setting.svg": [
		98195,
		98195
	],
	"./Database-Subtract-2-Raid-Storage-Code-Disk-Programming-Database-Array-Hard-Disc-Minus.svg": [
		52641,
		52641
	],
	"./Database.svg": [
		74487,
		74487
	],
	"./Decent-Work-And-Economic-Growth.svg": [
		47932,
		47932
	],
	"./Definition-Search-Book.svg": [
		17543,
		17543
	],
	"./Delete-1.svg": [
		31418,
		31418
	],
	"./Delete-Keyboard.svg": [
		60132,
		60132
	],
	"./Descending-Number-Order.svg": [
		99986,
		99986
	],
	"./Desktop-Chat.svg": [
		43731,
		43731
	],
	"./Desktop-Check.svg": [
		70521,
		70521
	],
	"./Desktop-Code.svg": [
		4779,
		4779
	],
	"./Desktop-Delete.svg": [
		97268,
		97268
	],
	"./Desktop-Dollar.svg": [
		79183,
		79183
	],
	"./Desktop-Emoji.svg": [
		17197,
		17197
	],
	"./Desktop-Favorite-Star.svg": [
		99463,
		99463
	],
	"./Desktop-Game.svg": [
		28325,
		28325
	],
	"./Desktop-Help.svg": [
		21024,
		21024
	],
	"./Device-Database-Encryption-1.svg": [
		17454,
		17454
	],
	"./Dhammajak.svg": [
		74229,
		74229
	],
	"./Diamond-2.svg": [
		1632,
		1632
	],
	"./Diamonds-Symbol.svg": [
		26487,
		26487
	],
	"./Dice-1.svg": [
		49734,
		49734
	],
	"./Dice-2.svg": [
		59373,
		59373
	],
	"./Dice-3.svg": [
		25293,
		25293
	],
	"./Dice-4.svg": [
		48067,
		48067
	],
	"./Dice-5.svg": [
		67869,
		67869
	],
	"./Dice-6.svg": [
		15164,
		15164
	],
	"./Dices-Entertainment-Gaming-Dices.svg": [
		49339,
		49339
	],
	"./Dictionary-Language-Book.svg": [
		25640,
		25640
	],
	"./Disable-Bell-Notification.svg": [
		37936,
		37936
	],
	"./Disable-Heart.svg": [
		82074,
		82074
	],
	"./Discord.svg": [
		96737,
		96737
	],
	"./Discount-Percent-Badge.svg": [
		40878,
		40878
	],
	"./Discount-Percent-Circle.svg": [
		6767,
		6767
	],
	"./Discount-Percent-Coupon.svg": [
		50208,
		50208
	],
	"./Discount-Percent-Cutout.svg": [
		39080,
		39080
	],
	"./Discount-Percent-Fire.svg": [
		6606,
		6606
	],
	"./Discussion-Converstion-Reply.svg": [
		4553,
		4553
	],
	"./Division-Circle.svg": [
		45445,
		45445
	],
	"./Dna.svg": [
		28249,
		28249
	],
	"./Dollar-Coin-1.svg": [
		10312,
		10312
	],
	"./Dollar-Coin.svg": [
		56165,
		56165
	],
	"./Donut.svg": [
		45569,
		45569
	],
	"./Download-Box-1.svg": [
		98710,
		98710
	],
	"./Download-Circle.svg": [
		11623,
		11623
	],
	"./Download-Computer.svg": [
		71736,
		71736
	],
	"./Download-File.svg": [
		13781,
		13781
	],
	"./Dressing-Table.svg": [
		74910,
		74910
	],
	"./Drone.svg": [
		97673,
		97673
	],
	"./Dropbox.svg": [
		82799,
		82799
	],
	"./Ear-Hearing.svg": [
		6556,
		6556
	],
	"./Earpods.svg": [
		8674,
		8674
	],
	"./Earth-1.svg": [
		84755,
		84755
	],
	"./Earth-Airplane.svg": [
		19467,
		19467
	],
	"./Edit-Image-Photo.svg": [
		86417,
		86417
	],
	"./Eject.svg": [
		61825,
		61825
	],
	"./Electric-Cord-1.svg": [
		40664,
		40664
	],
	"./Electric-Cord-3.svg": [
		95906,
		95906
	],
	"./Emergency-Exit.svg": [
		29880,
		29880
	],
	"./Empty-Clipboard.svg": [
		71821,
		71821
	],
	"./Epic-Games-1.svg": [
		64724,
		64724
	],
	"./Equal-Sign.svg": [
		37287,
		37287
	],
	"./Erlenmeyer-Flask.svg": [
		93026,
		93026
	],
	"./Esports.svg": [
		22210,
		22210
	],
	"./Ethereum-Circle.svg": [
		80608,
		80608
	],
	"./Ethereum.svg": [
		99042,
		99042
	],
	"./Euro.svg": [
		77854,
		77854
	],
	"./Expand-Horizontal-1.svg": [
		94816,
		94816
	],
	"./Expand-Window-2.svg": [
		46663,
		46663
	],
	"./Expand.svg": [
		12571,
		12571
	],
	"./Eye-Optic.svg": [
		4445,
		4445
	],
	"./Face-Scan-1.svg": [
		67861,
		67861
	],
	"./Facebook-1.svg": [
		1918,
		1918
	],
	"./Factorial.svg": [
		90615,
		90615
	],
	"./Fahrenheit.svg": [
		39175,
		39175
	],
	"./Fastforward-Clock.svg": [
		81716,
		81716
	],
	"./Figma.svg": [
		85729,
		85729
	],
	"./File-Add-Alternate.svg": [
		81037,
		81037
	],
	"./File-Code-1.svg": [
		34627,
		34627
	],
	"./File-Delete-Alternate.svg": [
		31095,
		31095
	],
	"./File-Remove-Alternate.svg": [
		45967,
		45967
	],
	"./Film-Roll-1.svg": [
		26159,
		26159
	],
	"./Film-Slate.svg": [
		39507,
		39507
	],
	"./Filter-2.svg": [
		49035,
		49035
	],
	"./Fingerprint-1.svg": [
		2933,
		2933
	],
	"./Fingerprint-2.svg": [
		74170,
		74170
	],
	"./Fire-Alarm-2.svg": [
		32881,
		32881
	],
	"./Fire-Extinguisher-Sign.svg": [
		96797,
		96797
	],
	"./Fireworks-Rocket.svg": [
		6779,
		6779
	],
	"./Fist.svg": [
		95189,
		95189
	],
	"./Fit-To-Height-Square.svg": [
		47751,
		47751
	],
	"./Flash-1.svg": [
		52540,
		52540
	],
	"./Flash-2.svg": [
		53625,
		53625
	],
	"./Flash-3.svg": [
		40831,
		40831
	],
	"./Flash-Off.svg": [
		56594,
		56594
	],
	"./Flip-Vertical-Arrow-2.svg": [
		21544,
		21544
	],
	"./Flip-Vertical-Circle-1.svg": [
		5762,
		5762
	],
	"./Flip-Vertical-Square-2.svg": [
		85362,
		85362
	],
	"./Floppy-Disk.svg": [
		5791,
		5791
	],
	"./Flower-1.svg": [
		76263,
		76263
	],
	"./Flower.svg": [
		59965,
		59965
	],
	"./Flu-Mask.svg": [
		28633,
		28633
	],
	"./Focus-Points.svg": [
		36978,
		36978
	],
	"./Folder-Add.svg": [
		50191,
		50191
	],
	"./Folder-Check.svg": [
		1,
		1
	],
	"./Folder-Delete.svg": [
		14858,
		14858
	],
	"./Fork-Knife.svg": [
		79787,
		79787
	],
	"./Fork-Spoon.svg": [
		53276,
		53276
	],
	"./Fragile.svg": [
		15827,
		15827
	],
	"./Front-Camera.svg": [
		29171,
		29171
	],
	"./Galaxy-1.svg": [
		46704,
		46704
	],
	"./Galaxy-2.svg": [
		51429,
		51429
	],
	"./Gameboy.svg": [
		8534,
		8534
	],
	"./Gas-Station-Fuel-Petroleum.svg": [
		53629,
		53629
	],
	"./Gender-Equality.svg": [
		88798,
		88798
	],
	"./Gif-Format.svg": [
		27816,
		27816
	],
	"./Gift-2.svg": [
		68072,
		68072
	],
	"./Gift.svg": [
		52379,
		52379
	],
	"./Give-Gift.svg": [
		69050,
		69050
	],
	"./Glasses.svg": [
		3257,
		3257
	],
	"./Global-Learning.svg": [
		44850,
		44850
	],
	"./Gmail.svg": [
		78776,
		78776
	],
	"./Gold.svg": [
		23129,
		23129
	],
	"./Good-Health-And-Well-Being.svg": [
		98056,
		98056
	],
	"./Google-Drive.svg": [
		81281,
		81281
	],
	"./Google.svg": [
		33768,
		33768
	],
	"./Graduation-Cap.svg": [
		94344,
		94344
	],
	"./Gramophone.svg": [
		70072,
		70072
	],
	"./Graph-Arrow-Decrease.svg": [
		95159,
		95159
	],
	"./Graph-Arrow-Increase.svg": [
		27954,
		27954
	],
	"./Graph-Bar-Decrease.svg": [
		45529,
		45529
	],
	"./Graph-Bar-Increase.svg": [
		95974,
		95974
	],
	"./Graph-Dot.svg": [
		78163,
		78163
	],
	"./Graph.svg": [
		68738,
		68738
	],
	"./Group-Meeting-Call.svg": [
		91533,
		91533
	],
	"./Half-Star-1.svg": [
		25480,
		25480
	],
	"./Hand-Cursor.svg": [
		44852,
		44852
	],
	"./Hand-Grab.svg": [
		34994,
		34994
	],
	"./Hand-Held-Tablet-Drawing.svg": [
		96330,
		96330
	],
	"./Hand-Held-Tablet-Writing.svg": [
		16762,
		16762
	],
	"./Hand-Held.svg": [
		77995,
		77995
	],
	"./Hang-Up-1.svg": [
		12578,
		12578
	],
	"./Hang-Up-2.svg": [
		18282,
		18282
	],
	"./Happy-Face.svg": [
		10350,
		10350
	],
	"./Hard-Disk.svg": [
		26498,
		26498
	],
	"./Hard-Drive-1.svg": [
		15570,
		15570
	],
	"./Heading-1-Paragraph-Styles-Heading.svg": [
		51402,
		51402
	],
	"./Heading-2-Paragraph-Styles-Heading.svg": [
		24930,
		24930
	],
	"./Heading-3-Paragraph-Styles-Heading.svg": [
		68379,
		68379
	],
	"./Health-Care-2.svg": [
		59737,
		59737
	],
	"./Hearing-Deaf-1.svg": [
		69994,
		69994
	],
	"./Hearing-Deaf-2.svg": [
		89391,
		78249
	],
	"./Heart-Fill.svg": [
		34039,
		34039
	],
	"./Heart-Rate-Pulse-Graph.svg": [
		34651,
		34651
	],
	"./Heart-Rate-Search.svg": [
		37379,
		37379
	],
	"./Heart.svg": [
		46642,
		46642
	],
	"./Hearts-Symbol.svg": [
		80780,
		80780
	],
	"./Help-Chat-2.svg": [
		62133,
		62133
	],
	"./Help-Question-1.svg": [
		75976,
		75976
	],
	"./Hexagram.svg": [
		53863,
		53863
	],
	"./Hierarchy-10.svg": [
		28960,
		28960
	],
	"./Hierarchy-13.svg": [
		95796,
		95796
	],
	"./Hierarchy-14.svg": [
		45036,
		45036
	],
	"./Hierarchy-2.svg": [
		48680,
		48680
	],
	"./Hierarchy-4.svg": [
		44088,
		44088
	],
	"./Hierarchy-7.svg": [
		48194,
		48194
	],
	"./High-Speed-Train-Front.svg": [
		49123,
		49123
	],
	"./Hinduism.svg": [
		35621,
		35621
	],
	"./Home-3.svg": [
		26402,
		26402
	],
	"./Home-4.svg": [
		92453,
		92453
	],
	"./Horizontal-Menu-Circle.svg": [
		31883,
		31883
	],
	"./Hospital-Sign-Circle.svg": [
		43941,
		43941
	],
	"./Hospital-Sign-Square.svg": [
		41449,
		41449
	],
	"./Hot-Spring.svg": [
		93556,
		93556
	],
	"./Hotel-Air-Conditioner.svg": [
		35042,
		35042
	],
	"./Hotel-Bed-2.svg": [
		94788,
		94788
	],
	"./Hotel-Laundry.svg": [
		41168,
		41168
	],
	"./Hotel-One-Star.svg": [
		82266,
		82266
	],
	"./Hotel-Shower-Head.svg": [
		13865,
		13865
	],
	"./Hotel-Two-Star.svg": [
		54290,
		54290
	],
	"./Humidity-None.svg": [
		17620,
		17620
	],
	"./Ice-Cream-2.svg": [
		87493,
		87493
	],
	"./Ice-Cream-3.svg": [
		33851,
		33851
	],
	"./Image-Blur.svg": [
		58418,
		58418
	],
	"./Image-Saturation.svg": [
		7722,
		7722
	],
	"./Inbox-Block.svg": [
		16213,
		16213
	],
	"./Inbox-Favorite-Heart.svg": [
		72402,
		72402
	],
	"./Inbox-Favorite.svg": [
		78771,
		78771
	],
	"./Inbox-Lock.svg": [
		3507,
		3507
	],
	"./Inbox-Tray-1.svg": [
		18258,
		18258
	],
	"./Inbox-Tray-2.svg": [
		25645,
		25645
	],
	"./Incognito-Mode.svg": [
		2126,
		2126
	],
	"./Incoming-Call.svg": [
		63765,
		63765
	],
	"./Industry-Innovation-And-Infrastructure.svg": [
		45707,
		45707
	],
	"./Information-Circle.svg": [
		10967,
		10967
	],
	"./Information-Desk-Customer.svg": [
		58530,
		58530
	],
	"./Information-Desk.svg": [
		39861,
		39861
	],
	"./Input-Box.svg": [
		31044,
		31044
	],
	"./Insert-Cloud-Video.svg": [
		27865,
		27865
	],
	"./Insert-Side.svg": [
		93448,
		93448
	],
	"./Insert-Top-Left.svg": [
		90184,
		90184
	],
	"./Insert-Top-Right.svg": [
		97624,
		97624
	],
	"./Instagram.svg": [
		13426,
		13426
	],
	"./Insurance-Hand.svg": [
		39212,
		39212
	],
	"./Investment-Selection.svg": [
		89190,
		89190
	],
	"./Invisible-1.svg": [
		32855,
		32855
	],
	"./Invisible-2.svg": [
		73469,
		73469
	],
	"./Iron.svg": [
		54611,
		54611
	],
	"./Islam.svg": [
		76029,
		76029
	],
	"./Issue-history.svg": [
		69611,
		89391
	],
	"./Issue-register.svg": [
		39465,
		39465
	],
	"./Jump-Object.svg": [
		60638,
		60638
	],
	"./Justice-Hammer.svg": [
		22157,
		22157
	],
	"./Justice-Scale-1.svg": [
		33581,
		33581
	],
	"./Justice-Scale-2.svg": [
		22975,
		22975
	],
	"./Key.svg": [
		23781,
		23781
	],
	"./Keyboard-Virtual.svg": [
		18553,
		18553
	],
	"./Keyboard-Wireless-2.svg": [
		78304,
		78304
	],
	"./Keyboard.svg": [
		55588,
		55588
	],
	"./Keyhole-Lock-Circle.svg": [
		6959,
		6959
	],
	"./Ladder.svg": [
		36661,
		36661
	],
	"./Landscape-2.svg": [
		21452,
		21452
	],
	"./Landscape-Setting.svg": [
		27784,
		58642
	],
	"./Laptop-Camera.svg": [
		19459,
		19459
	],
	"./Laptop-Charging.svg": [
		50473,
		50473
	],
	"./Lasso-Tool.svg": [
		59287,
		59287
	],
	"./Layers-1.svg": [
		73300,
		73300
	],
	"./Layers-2.svg": [
		9744,
		9744
	],
	"./Layout-Window-1.svg": [
		91442,
		91442
	],
	"./Layout-Window-11.svg": [
		18040,
		18040
	],
	"./Layout-Window-2.svg": [
		10061,
		10061
	],
	"./Layout-Window-8.svg": [
		3621,
		3621
	],
	"./Leaf.svg": [
		84858,
		84858
	],
	"./Lemon-Fruit-Seasoning.svg": [
		24045,
		24045
	],
	"./Lift-Disability.svg": [
		21005,
		21005
	],
	"./Lift.svg": [
		90606,
		90606
	],
	"./Lightbulb.svg": [
		97249,
		97249
	],
	"./Like-1-Fill.svg": [
		10962,
		10962
	],
	"./Like-1.svg": [
		78227,
		78227
	],
	"./Link-Chain.svg": [
		88855,
		88855
	],
	"./Linkedin.svg": [
		63626,
		63626
	],
	"./Lipstick.svg": [
		63059,
		63059
	],
	"./Live-Video.svg": [
		50125,
		50125
	],
	"./Local-Storage-Folder.svg": [
		55882,
		55882
	],
	"./Location-Compass-1.svg": [
		45911,
		45911
	],
	"./Location-Pin-3.svg": [
		56787,
		56787
	],
	"./Location-Pin-Disabled.svg": [
		55855,
		55855
	],
	"./Location-Target-1.svg": [
		59798,
		59798
	],
	"./Lock-Rotation.svg": [
		37286,
		37286
	],
	"./Log.svg": [
		22366,
		22366
	],
	"./Login-1.svg": [
		62388,
		62388
	],
	"./Logout-1.svg": [
		45468,
		45468
	],
	"./Loop-1.svg": [
		37086,
		37086
	],
	"./Lost-And-Found.svg": [
		26853,
		26853
	],
	"./Magic-Wand-2.svg": [
		14835,
		14835
	],
	"./Magnifying-Glass-Circle.svg": [
		11526,
		11526
	],
	"./Magnifying-Glass.svg": [
		36593,
		36593
	],
	"./Mail-Incoming.svg": [
		4856,
		4856
	],
	"./Mail-Search.svg": [
		19982,
		19982
	],
	"./Mail-Send-Email-Message.svg": [
		42723,
		42723
	],
	"./Mail-Send-Envelope.svg": [
		31292,
		31292
	],
	"./Mail-Send-Reply-All.svg": [
		6048,
		6048
	],
	"./Make-Up-Brush.svg": [
		74375,
		74375
	],
	"./Man-Symbol.svg": [
		25763,
		25763
	],
	"./Manual-Book.svg": [
		46850,
		46850
	],
	"./Map-Fold.svg": [
		83252,
		83252
	],
	"./Markdown-Circle-Programming.svg": [
		62248,
		62248
	],
	"./Markdown-Document-Programming.svg": [
		67926,
		67926
	],
	"./Medical-Bag.svg": [
		78363,
		78363
	],
	"./Medical-Cross-Sign-Healthcare.svg": [
		71908,
		71908
	],
	"./Medical-Cross-Symbol.svg": [
		30422,
		30422
	],
	"./Medical-Files-Report-History.svg": [
		54017,
		54017
	],
	"./Medical-Ribbon-1.svg": [
		38381,
		38381
	],
	"./Medical-Search-Diagnosis.svg": [
		31497,
		31497
	],
	"./Megaphone-2.svg": [
		39682,
		39682
	],
	"./Meta.svg": [
		53695,
		53695
	],
	"./Microscope-Observation-Sciene.svg": [
		97559,
		97559
	],
	"./Microwave.svg": [
		67008,
		67008
	],
	"./Milkshake.svg": [
		57037,
		57037
	],
	"./Minimize-Window-2.svg": [
		58520,
		58520
	],
	"./Missed-Call.svg": [
		70431,
		70431
	],
	"./Mobile-Phone-Camera.svg": [
		51266,
		51266
	],
	"./Module-Puzzle-1.svg": [
		80841,
		80841
	],
	"./Module-Puzzle-3.svg": [
		92917,
		92917
	],
	"./Module-Three.svg": [
		27062,
		27062
	],
	"./Moon-Cloud.svg": [
		40301,
		40301
	],
	"./Mouse-Wireless-1.svg": [
		67292,
		67292
	],
	"./Mouse-Wireless.svg": [
		43003,
		43003
	],
	"./Mouse.svg": [
		2221,
		2221
	],
	"./Moustache.svg": [
		25260,
		25260
	],
	"./Mouth-Lip.svg": [
		90791,
		90791
	],
	"./Move-Left.svg": [
		75206,
		75206
	],
	"./Move-Right.svg": [
		52262,
		52262
	],
	"./Multiple-File-2.svg": [
		21183,
		21183
	],
	"./Music-Equalizer.svg": [
		1239,
		1239
	],
	"./Music-Folder-Song.svg": [
		77934,
		77934
	],
	"./Music-Note-1.svg": [
		87233,
		87233
	],
	"./Music-Note-2.svg": [
		5675,
		5675
	],
	"./Music-Note-Off-1.svg": [
		11501,
		11501
	],
	"./Music-Note-Off-2.svg": [
		19358,
		19358
	],
	"./Navigation-Arrow-Off.svg": [
		60322,
		60322
	],
	"./Navigation-Arrow-On.svg": [
		44286,
		44286
	],
	"./Necklace.svg": [
		32377,
		32377
	],
	"./Necktie.svg": [
		78041,
		78041
	],
	"./Netflix.svg": [
		83090,
		83090
	],
	"./Network.svg": [
		56304,
		56304
	],
	"./New-File.svg": [
		91627,
		91627
	],
	"./New-Folder.svg": [
		54210,
		54210
	],
	"./New-Sticky-Note.svg": [
		51549,
		51549
	],
	"./News-Paper.svg": [
		10203,
		10203
	],
	"./Next.svg": [
		36438,
		36438
	],
	"./Nintendo-Switch.svg": [
		60325,
		60325
	],
	"./No-Poverty.svg": [
		12965,
		12965
	],
	"./Not-Equal-Sign.svg": [
		84909,
		84909
	],
	"./Notification-Alarm-2.svg": [
		52975,
		52975
	],
	"./Notification-Application-1.svg": [
		52929,
		52929
	],
	"./Notification-Application-2.svg": [
		69893,
		69893
	],
	"./Notification-Message-Alert.svg": [
		56114,
		56114
	],
	"./Nurse-Assistant-Emergency.svg": [
		30929,
		30929
	],
	"./Nurse-Hat.svg": [
		76109,
		76109
	],
	"./Octopus.svg": [
		22450,
		22450
	],
	"./Office-Building-1.svg": [
		67357,
		67357
	],
	"./Office-Worker.svg": [
		31148,
		31148
	],
	"./Ok-Hand.svg": [
		47896,
		46677
	],
	"./One-Finger-Drag-Horizontal.svg": [
		29399,
		29399
	],
	"./One-Finger-Drag-Vertical.svg": [
		13124,
		13124
	],
	"./One-Finger-Hold.svg": [
		51527,
		51527
	],
	"./One-Finger-Tap.svg": [
		81181,
		81181
	],
	"./One-Vesus-One.svg": [
		26096,
		26096
	],
	"./Online-Medical-Call-Service.svg": [
		35398,
		35398
	],
	"./Online-Medical-Service-Monitor.svg": [
		20644,
		20644
	],
	"./Online-Medical-Web-Service.svg": [
		8834,
		8834
	],
	"./Open-Book.svg": [
		28462,
		28462
	],
	"./Open-Umbrella.svg": [
		4923,
		4923
	],
	"./Orientation-Landscape.svg": [
		75219,
		75219
	],
	"./Orientation-Portrait.svg": [
		48302,
		48302
	],
	"./Outgoing-Call.svg": [
		64675,
		64675
	],
	"./Pacman.svg": [
		56182,
		56182
	],
	"./Padlock-Square-1.svg": [
		20081,
		20081
	],
	"./Page-Setting.svg": [
		78698,
		78698
	],
	"./Paint-Bucket.svg": [
		2914,
		2914
	],
	"./Paint-Palette.svg": [
		72455,
		72455
	],
	"./Paintbrush-1.svg": [
		26506,
		26506
	],
	"./Paintbrush-2.svg": [
		21597,
		21597
	],
	"./Paperclip-1.svg": [
		96450,
		96450
	],
	"./Parachute-Drop.svg": [
		53220,
		53220
	],
	"./Paragraph.svg": [
		97609,
		97609
	],
	"./Parking-Sign.svg": [
		44487,
		44487
	],
	"./Parliament.svg": [
		29223,
		29223
	],
	"./Party-Popper.svg": [
		96608,
		96608
	],
	"./Passport.svg": [
		81848,
		81848
	],
	"./Pathfinder-Divide.svg": [
		42708,
		42708
	],
	"./Pathfinder-Exclude.svg": [
		53380,
		53380
	],
	"./Pathfinder-Intersect.svg": [
		66163,
		66163
	],
	"./Pathfinder-Merge.svg": [
		82609,
		82609
	],
	"./Pathfinder-Minus-Front-1.svg": [
		79429,
		79429
	],
	"./Pathfinder-Trim.svg": [
		6965,
		6965
	],
	"./Pathfinder-Union.svg": [
		81675,
		81675
	],
	"./Payment-10.svg": [
		53165,
		53165
	],
	"./Payment-Cash-Out-3.svg": [
		435,
		435
	],
	"./Paypal.svg": [
		75032,
		75032
	],
	"./Peace-Hand.svg": [
		91146,
		91146
	],
	"./Peace-Symbol.svg": [
		73514,
		73514
	],
	"./Pen-3.svg": [
		26146,
		26146
	],
	"./Pen-Draw.svg": [
		66292,
		85764
	],
	"./Pen-Tool.svg": [
		94859,
		94859
	],
	"./Pencil.svg": [
		65034,
		65034
	],
	"./Pentagon.svg": [
		15588,
		15588
	],
	"./Pet-Paw.svg": [
		13417,
		13417
	],
	"./Petri-Dish-Lab-Equipment.svg": [
		40015,
		40015
	],
	"./Pets-Allowed.svg": [
		47627,
		47627
	],
	"./Pharmacy.svg": [
		50103,
		50103
	],
	"./Phone-Mobile-Phone.svg": [
		45362,
		45362
	],
	"./Phone-Qr.svg": [
		74845,
		74845
	],
	"./Phone-Ringing-1.svg": [
		60057,
		69532
	],
	"./Phone-Ringing-2.svg": [
		25581,
		25581
	],
	"./Phone.svg": [
		69388,
		69388
	],
	"./Pi-Symbol-Circle.svg": [
		86225,
		86225
	],
	"./Pictures-Folder-Memories.svg": [
		17025,
		17025
	],
	"./Pie-Chart.svg": [
		21746,
		21746
	],
	"./Piggy-Bank.svg": [
		66005,
		66005
	],
	"./Planet.svg": [
		7230,
		7230
	],
	"./Play-List-4.svg": [
		9575,
		9575
	],
	"./Play-List-5.svg": [
		86085,
		86085
	],
	"./Play-List-8.svg": [
		60642,
		60642
	],
	"./Play-List-9.svg": [
		86885,
		86885
	],
	"./Play-List-Folder.svg": [
		49983,
		49983
	],
	"./Play-Station.svg": [
		8641,
		8641
	],
	"./Play-Store.svg": [
		94634,
		94634
	],
	"./Podium.svg": [
		47521,
		47521
	],
	"./Polaroid-Four.svg": [
		6336,
		6336
	],
	"./Politics-Compaign.svg": [
		74714,
		74714
	],
	"./Politics-Speech.svg": [
		47733,
		47733
	],
	"./Politics-Vote-2.svg": [
		71841,
		71841
	],
	"./Polka-Dot-Circle.svg": [
		36719,
		36719
	],
	"./Polygon.svg": [
		23721,
		23721
	],
	"./Pool-Ladder.svg": [
		80733,
		80733
	],
	"./Popcorn.svg": [
		82541,
		82541
	],
	"./Pork-Meat.svg": [
		20020,
		20020
	],
	"./Potted-Flower-Tulip.svg": [
		15327,
		15327
	],
	"./Praying-Hand.svg": [
		12019,
		12019
	],
	"./Prescription-Pills-Drugs-Healthcare.svg": [
		53782,
		53782
	],
	"./Printer.svg": [
		16382,
		16382
	],
	"./Production-Belt.svg": [
		31227,
		31227
	],
	"./Projector-Board.svg": [
		22024,
		22024
	],
	"./Pyramid-Shape.svg": [
		63563,
		63563
	],
	"./Qr-Code.svg": [
		59848,
		82659
	],
	"./Quality-Education.svg": [
		56928,
		56928
	],
	"./Quotation-2.svg": [
		80688,
		80688
	],
	"./Radio.svg": [
		2811,
		2811
	],
	"./Radioactive-2.svg": [
		79187,
		79187
	],
	"./Rain-Cloud.svg": [
		14537,
		14537
	],
	"./Rainbow.svg": [
		33914,
		33914
	],
	"./Receipt-Add.svg": [
		56023,
		56023
	],
	"./Receipt-Check.svg": [
		55653,
		55653
	],
	"./Receipt-Subtract.svg": [
		99927,
		99927
	],
	"./Receipt.svg": [
		89095,
		89095
	],
	"./Recording-Tape-Bubble-Circle.svg": [
		67969,
		67969
	],
	"./Recording-Tape-Bubble-Square.svg": [
		24190,
		24190
	],
	"./Recycle-1.svg": [
		97188,
		97188
	],
	"./Recycle-Bin-2.svg": [
		98528,
		98528
	],
	"./Reduced-Inequalities.svg": [
		87487,
		87487
	],
	"./Refrigerator.svg": [
		65459,
		65459
	],
	"./Return-2.svg": [
		66646,
		66646
	],
	"./Ringing-Bell-Notification.svg": [
		91080,
		91080
	],
	"./Rock-And-Roll-Hand.svg": [
		19590,
		19590
	],
	"./Rock-Slide.svg": [
		47449,
		47449
	],
	"./Rose.svg": [
		99862,
		99862
	],
	"./Rotate-Angle-45.svg": [
		56589,
		56589
	],
	"./Round-Cap.svg": [
		44339,
		44339
	],
	"./Rss-Square.svg": [
		5642,
		5642
	],
	"./Rss-Symbol.svg": [
		36266,
		36266
	],
	"./Sad-Face.svg": [
		37108,
		37108
	],
	"./Safe-Vault.svg": [
		43981,
		43981
	],
	"./Sail-Ship.svg": [
		82612,
		82612
	],
	"./Satellite-Dish.svg": [
		43252,
		59848
	],
	"./Scanner-3.svg": [
		13905,
		13905
	],
	"./Scanner-Bar-Code.svg": [
		78791,
		78791
	],
	"./Scanner.svg": [
		50671,
		50671
	],
	"./School-Bus-Side.svg": [
		45488,
		45488
	],
	"./Screen-1.svg": [
		42350,
		42350
	],
	"./Screen-2.svg": [
		73451,
		73451
	],
	"./Screen-Broadcast.svg": [
		73402,
		73402
	],
	"./Screen-Curve.svg": [
		91070,
		91070
	],
	"./Screensaver-Monitor-Wallpaper.svg": [
		57690,
		57690
	],
	"./Script-2.svg": [
		695,
		695
	],
	"./Search-Dollar.svg": [
		75810,
		7168
	],
	"./Search-Visual.svg": [
		66422,
		66422
	],
	"./Select-Circle-Area-1.svg": [
		38547,
		38547
	],
	"./Send-Email.svg": [
		72149,
		72149
	],
	"./Serving-Dome.svg": [
		10597,
		10597
	],
	"./Share-Link.svg": [
		38332,
		38332
	],
	"./Shelf.svg": [
		70483,
		70483
	],
	"./Shell.svg": [
		75093,
		75093
	],
	"./Shield-1.svg": [
		68776,
		68776
	],
	"./Shield-2.svg": [
		87697,
		87697
	],
	"./Shield-Check.svg": [
		15527,
		15527
	],
	"./Shield-Cross.svg": [
		32609,
		32609
	],
	"./Shift.svg": [
		5594,
		5594
	],
	"./Shipment-Add.svg": [
		25220,
		25220
	],
	"./Shipment-Check.svg": [
		5856,
		5856
	],
	"./Shipment-Download.svg": [
		2352,
		2352
	],
	"./Shipment-Remove.svg": [
		26307,
		26307
	],
	"./Shipment-Upload.svg": [
		4158,
		4158
	],
	"./Shipping-Box-1.svg": [
		36056,
		36056
	],
	"./Shipping-Truck.svg": [
		97779,
		97779
	],
	"./Shopping-Bag-Hand-Bag-2.svg": [
		77329,
		77329
	],
	"./Shopping-Basket-1.svg": [
		85538,
		85538
	],
	"./Shopping-Basket-2.svg": [
		73657,
		73657
	],
	"./Shopping-Cart-1.svg": [
		21538,
		21538
	],
	"./Shopping-Cart-2.svg": [
		13440,
		13440
	],
	"./Shopping-Cart-3.svg": [
		7321,
		7321
	],
	"./Shopping-Cart-Add.svg": [
		60068,
		60068
	],
	"./Shopping-Cart-Check.svg": [
		18289,
		18289
	],
	"./Shopping-Cart-Subtract.svg": [
		84275,
		16557
	],
	"./Shovel-Rake.svg": [
		42408,
		42408
	],
	"./Shredder.svg": [
		18407,
		18407
	],
	"./Shrimp.svg": [
		18663,
		18663
	],
	"./Shrink-Horizontal-1.svg": [
		5053,
		5053
	],
	"./Shuffle.svg": [
		18106,
		18106
	],
	"./Sigma.svg": [
		89653,
		89653
	],
	"./Sign-At.svg": [
		74111,
		74111
	],
	"./Sign-Cross-Square.svg": [
		17778,
		17778
	],
	"./Sign-Hashtag.svg": [
		23315,
		23315
	],
	"./Signage-3.svg": [
		37154,
		37154
	],
	"./Signage-4.svg": [
		72806,
		72806
	],
	"./Signal-Full.svg": [
		30300,
		30300
	],
	"./Signal-Loading.svg": [
		16497,
		16497
	],
	"./Signal-Low.svg": [
		69659,
		69659
	],
	"./Signal-Medium.svg": [
		72030,
		72030
	],
	"./Signal-None.svg": [
		34634,
		34634
	],
	"./Skull-1.svg": [
		35699,
		35699
	],
	"./Slack.svg": [
		85778,
		85778
	],
	"./Sleep.svg": [
		14277,
		14277
	],
	"./Smiley-Angry.svg": [
		75581,
		75581
	],
	"./Smiley-Cool.svg": [
		61177,
		61177
	],
	"./Smiley-Crying-1.svg": [
		43338,
		43338
	],
	"./Smiley-Cute.svg": [
		10681,
		10681
	],
	"./Smiley-Drool.svg": [
		68012,
		68012
	],
	"./Smiley-Emoji-Kiss-Nervous.svg": [
		95130,
		95130
	],
	"./Smiley-Emoji-Terrified.svg": [
		26842,
		26842
	],
	"./Smiley-Grumpy.svg": [
		82113,
		82113
	],
	"./Smiley-Happy.svg": [
		63436,
		63436
	],
	"./Smiley-In-Love.svg": [
		54946,
		54946
	],
	"./Smiley-Kiss.svg": [
		37136,
		37136
	],
	"./Smiley-Laughing-3.svg": [
		2243,
		2243
	],
	"./Smiley-Mask.svg": [
		63347,
		63347
	],
	"./Smiley-Nauseas.svg": [
		71177,
		71177
	],
	"./Smiley-Smirk.svg": [
		24044,
		24044
	],
	"./Smiley-Sparks.svg": [
		91348,
		91348
	],
	"./Smiley-Surprised.svg": [
		21772,
		21772
	],
	"./Smiley-Throw-Up.svg": [
		82957,
		82957
	],
	"./Smiley-Very-Shocked.svg": [
		16585,
		16585
	],
	"./Smoke-Detector.svg": [
		88032,
		88032
	],
	"./Smoking-Area.svg": [
		50141,
		50141
	],
	"./Snorkle.svg": [
		45275,
		45275
	],
	"./Snow-Flake.svg": [
		66916,
		66916
	],
	"./Song-Recommendation.svg": [
		66616,
		66616
	],
	"./Sort-Descending.svg": [
		71581,
		71581
	],
	"./Sos-Help-Emergency-Sign.svg": [
		21965,
		21965
	],
	"./Spades-Symbol.svg": [
		63683,
		63683
	],
	"./Speaker-1.svg": [
		4289,
		4289
	],
	"./Speaker-2.svg": [
		76814,
		76814
	],
	"./Spiral-Shape.svg": [
		66031,
		66031
	],
	"./Split-Vertical.svg": [
		33477,
		33477
	],
	"./Spotify.svg": [
		49976,
		49976
	],
	"./Spray-Paint.svg": [
		28115,
		28115
	],
	"./Sprout.svg": [
		54950,
		54950
	],
	"./Square-Brackets-Circle.svg": [
		11255,
		11255
	],
	"./Square-Cap.svg": [
		41648,
		41648
	],
	"./Square-Clock.svg": [
		46467,
		46467
	],
	"./Square-Root-X-Circle.svg": [
		56886,
		56886
	],
	"./Star-2.svg": [
		91906,
		91906
	],
	"./Star-Badge.svg": [
		13987,
		13987
	],
	"./Startup.svg": [
		35383,
		35383
	],
	"./Steering-Wheel.svg": [
		59067,
		59067
	],
	"./Steps-Number.svg": [
		25579,
		25579
	],
	"./Stethoscope.svg": [
		98731,
		98731
	],
	"./Stock.svg": [
		27491,
		27491
	],
	"./Store-1.svg": [
		99388,
		99388
	],
	"./Store-2.svg": [
		1232,
		1232
	],
	"./Store-Computer.svg": [
		89782,
		89782
	],
	"./Straight-Cap.svg": [
		97981,
		97981
	],
	"./Straight-Face.svg": [
		76378,
		76378
	],
	"./Strategy-Tasks.svg": [
		86847,
		86847
	],
	"./Strawberry.svg": [
		26196,
		26196
	],
	"./Stream.svg": [
		7096,
		7096
	],
	"./Street-Road.svg": [
		42425,
		42425
	],
	"./Street-Sign.svg": [
		64567,
		64567
	],
	"./Subscription-Cashflow.svg": [
		51130,
		51130
	],
	"./Subtract-1.svg": [
		4655,
		4655
	],
	"./Subtract-Circle.svg": [
		76700,
		76700
	],
	"./Subtract-Square.svg": [
		43979,
		43979
	],
	"./Sun-Cloud.svg": [
		8894,
		8894
	],
	"./Synchronize-Disable.svg": [
		95326,
		95326
	],
	"./Synchronize-Warning.svg": [
		85551,
		85551
	],
	"./Syringe.svg": [
		2096,
		2096
	],
	"./Table-Lamp-1.svg": [
		94237,
		94237
	],
	"./Tablet-Capsule.svg": [
		32997,
		32997
	],
	"./Tag-1.svg": [
		49730,
		49730
	],
	"./Tag.svg": [
		98910,
		98910
	],
	"./Take-Off.svg": [
		43527,
		43527
	],
	"./Tall-Hat.svg": [
		29524,
		29524
	],
	"./Tape-Cassette-Record.svg": [
		69916,
		69916
	],
	"./Target-3.svg": [
		73921,
		73921
	],
	"./Target.svg": [
		94658,
		94658
	],
	"./Task-List.svg": [
		31221,
		31221
	],
	"./Tea-Cup.svg": [
		26635,
		26635
	],
	"./Telegram.svg": [
		67319,
		67319
	],
	"./Telescope.svg": [
		25838,
		25838
	],
	"./Test-Tube.svg": [
		16049,
		16049
	],
	"./Text-Flow-Rows.svg": [
		20474,
		20474
	],
	"./Text-Square.svg": [
		89571,
		89571
	],
	"./Text-Style.svg": [
		41141,
		41141
	],
	"./TextFieldX.svg": [
		95868,
		95868
	],
	"./Thermometer.svg": [
		99607,
		99607
	],
	"./Threat-Browser-1.svg": [
		48419,
		48419
	],
	"./Threat-Document.svg": [
		3030,
		3030
	],
	"./Threat-Folder.svg": [
		663,
		663
	],
	"./Ticket-1.svg": [
		22752,
		22752
	],
	"./Tickets.svg": [
		10374,
		10374
	],
	"./Tidal-Wave.svg": [
		92593,
		92593
	],
	"./Tiktok.svg": [
		62649,
		62649
	],
	"./Tinder.svg": [
		25282,
		25282
	],
	"./Toast.svg": [
		16999,
		16999
	],
	"./Toilet-Man.svg": [
		73562,
		73562
	],
	"./Toilet-Sign-Man-Woman-2.svg": [
		33770,
		33770
	],
	"./Toilet-Women.svg": [
		36365,
		36365
	],
	"./Tooth.svg": [
		2073,
		2073
	],
	"./Traffic-Cone.svg": [
		17951,
		17951
	],
	"./Transfer-Motorcycle.svg": [
		99378,
		99378
	],
	"./Transfer-Van.svg": [
		10505,
		10505
	],
	"./Tree-2.svg": [
		7806,
		7806
	],
	"./Tree-3.svg": [
		49458,
		49458
	],
	"./Trending-Content.svg": [
		3706,
		3706
	],
	"./Triangle-Flag.svg": [
		72438,
		72438
	],
	"./Trophy.svg": [
		13211,
		13211
	],
	"./Twitter.svg": [
		84652,
		84652
	],
	"./Two-Finger-Drag-Hotizontal.svg": [
		79563,
		79563
	],
	"./Two-Finger-Tap.svg": [
		93825,
		93825
	],
	"./Underline-Text-1.svg": [
		31471,
		31471
	],
	"./Upload-Box-1.svg": [
		95849,
		95849
	],
	"./Upload-Circle.svg": [
		17387,
		17387
	],
	"./Upload-Computer.svg": [
		724,
		724
	],
	"./Upload-File.svg": [
		58335,
		58335
	],
	"./Usb-Drive.svg": [
		87879,
		87879
	],
	"./User-Add-Plus.svg": [
		48517,
		48517
	],
	"./User-Check-Validate.svg": [
		90608,
		90608
	],
	"./User-Circle-Single.svg": [
		24038,
		24038
	],
	"./User-Identifier-Card.svg": [
		53886,
		53886
	],
	"./User-Multiple-Circle.svg": [
		87521,
		87521
	],
	"./User-Multiple-Group.svg": [
		54531,
		54531
	],
	"./User-Profile-Focus.svg": [
		83126,
		83126
	],
	"./User-Protection-2.svg": [
		13492,
		13492
	],
	"./User-Remove-Subtract.svg": [
		47808,
		47808
	],
	"./User-Single-Neutral-Male.svg": [
		60224,
		60224
	],
	"./User-Sync-Online-In-Person.svg": [
		64951,
		64951
	],
	"./Vertical-Slider-Square.svg": [
		4225,
		4225
	],
	"./Video-Swap-Camera.svg": [
		71666,
		71666
	],
	"./Virtual-Reality.svg": [
		90801,
		90801
	],
	"./Virus-Antivirus.svg": [
		86908,
		86908
	],
	"./Visible.svg": [
		76506,
		76506
	],
	"./Voice-Mail-Off.svg": [
		19854,
		19854
	],
	"./Voice-Mail.svg": [
		26320,
		26320
	],
	"./Voice-Scan-2.svg": [
		1748,
		1748
	],
	"./Volcano.svg": [
		89407,
		89407
	],
	"./Volume-Down.svg": [
		25200,
		25200
	],
	"./Volume-Level-High.svg": [
		16233,
		16233
	],
	"./Volume-Level-Low.svg": [
		91039,
		91039
	],
	"./Volume-Level-Off.svg": [
		71388,
		71388
	],
	"./Volume-Mute.svg": [
		80985,
		80985
	],
	"./Volume-Off.svg": [
		71396,
		71396
	],
	"./Vpn-Connection.svg": [
		13992,
		13992
	],
	"./Vr-Headset-1.svg": [
		35236,
		35236
	],
	"./Vr-Headset-2.svg": [
		9553,
		9553
	],
	"./Waiting-Appointments-Calendar.svg": [
		19305,
		19305
	],
	"./Wallet-Purse.svg": [
		52326,
		52326
	],
	"./Wallet.svg": [
		63299,
		63299
	],
	"./Waning-Cresent-Moon.svg": [
		33834,
		33834
	],
	"./Warehouse-1.svg": [
		25245,
		25245
	],
	"./Warning-Octagon.svg": [
		94697,
		94697
	],
	"./Warning-Triangle.svg": [
		34068,
		34068
	],
	"./Watch-1.svg": [
		18013,
		18013
	],
	"./Watch-2.svg": [
		90792,
		90792
	],
	"./Watch-Circle-Charging.svg": [
		55478,
		55478
	],
	"./Watch-Circle-Heartbeat-Monitor-1.svg": [
		56392,
		56392
	],
	"./Watch-Circle-Heartbeat-Monitor-2.svg": [
		39580,
		39580
	],
	"./Watch-Circle-Menu.svg": [
		12418,
		12418
	],
	"./Watch-Circle-Time.svg": [
		20891,
		20891
	],
	"./Water-Glass.svg": [
		38174,
		38174
	],
	"./Wave-Signal-Square.svg": [
		11267,
		11267
	],
	"./Wave-Signal.svg": [
		44092,
		44092
	],
	"./Waving-Hand.svg": [
		54283,
		54283
	],
	"./Web.svg": [
		86686,
		86686
	],
	"./Webcam-Video-Circle.svg": [
		74141,
		74141
	],
	"./Webcam-Video-Off.svg": [
		8386,
		8386
	],
	"./Webcam-Video.svg": [
		47716,
		47716
	],
	"./Webcam.svg": [
		30374,
		30374
	],
	"./Whatsapp.svg": [
		99215,
		99215
	],
	"./Wheelchair-1.svg": [
		15652,
		15652
	],
	"./Wheelchair.svg": [
		19907,
		19907
	],
	"./Widget.svg": [
		98381,
		98381
	],
	"./Wifi-Antenna.svg": [
		47455,
		47455
	],
	"./Wifi-Disabled.svg": [
		27108,
		27108
	],
	"./Wifi-Horizontal.svg": [
		38341,
		38341
	],
	"./Wifi-Router.svg": [
		64021,
		64021
	],
	"./Wifi.svg": [
		26396,
		26396
	],
	"./Wind-Flow-1.svg": [
		77581,
		77581
	],
	"./Wind-Flow-2.svg": [
		36567,
		36567
	],
	"./Windmill.svg": [
		39597,
		39597
	],
	"./Windows.svg": [
		1564,
		1564
	],
	"./Wine.svg": [
		85813,
		85813
	],
	"./Woman-Symbol.svg": [
		86426,
		86426
	],
	"./Workspace-Desk.svg": [
		89939,
		89939
	],
	"./Wrench.svg": [
		58533,
		58533
	],
	"./Xbox.svg": [
		44419,
		44419
	],
	"./Xrp-Circle.svg": [
		7525,
		7525
	],
	"./Yin-Yang-Symbol.svg": [
		87786,
		87786
	],
	"./Yuan-Circle.svg": [
		42482,
		42482
	],
	"./Yuan.svg": [
		31901,
		31901
	],
	"./Zero-Hunger.svg": [
		3995,
		3995
	],
	"./Zodiac-1.svg": [
		35497,
		35497
	],
	"./Zodiac-10.svg": [
		12239,
		90501
	],
	"./Zodiac-11.svg": [
		62476,
		62476
	],
	"./Zodiac-12.svg": [
		22618,
		22618
	],
	"./Zodiac-2.svg": [
		16270,
		16270
	],
	"./Zodiac-3.svg": [
		21425,
		21425
	],
	"./Zodiac-4.svg": [
		71602,
		71602
	],
	"./Zodiac-5.svg": [
		56600,
		56600
	],
	"./Zodiac-6.svg": [
		75547,
		75547
	],
	"./Zodiac-7.svg": [
		81140,
		81140
	],
	"./Zodiac-8.svg": [
		65076,
		65076
	],
	"./Zodiac-9.svg": [
		17566,
		17566
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70662;
module.exports = webpackAsyncContext;